import React from 'react';
import _ from 'lodash';
import { Link } from 'react-isomorphic-render';
import PropTypes from 'prop-types';
import { components } from '@glowforge/ui-common';

import './jobs-list.less';

const { Markdown } = components;

const JobsList = (props) => {
  const categories = {};
  _.forEach(props.jobs, function(job) { //eslint-disable-line
    if (job.category) {
      if (!categories[job.category]) categories[job.category] = [];
      categories[job.category].push(<Link key={job.slug} to={`/jobs/${job.slug}`}>{job.title}</Link>);
    }
  }, this);

  const sortedCat = _.keys(categories).sort();

  const jobsList = [];
  _.forEach(sortedCat, (category, index) => {
    jobsList.push(
      <div className='category' key={index}>
        <h3 className='h4'>{category}</h3>
        {categories[category]}
      </div>,
    );
  });

  const title = _.get(
    _.find(props.textStrings, { fields: { id: 'jobs-current-openings-title' } }),
    'fields.text',
  );

  const subTitle = _.get(
    _.find(props.textStrings, { fields: { id: 'jobs-current-openings-subtext' } }),
    'fields.text',
  );

  return (
    <div id='jobs-homes-openings' className='JobsList'>
      <h1 className='h2'>{title}</h1>
      <Markdown className='subTitle paragraph' source={subTitle} />
      <div className='listings'>
        <div className='col'>{_.slice(jobsList, 0, Math.ceil(jobsList.length / 2))}</div>
        <div className='col'>{_.slice(jobsList, Math.ceil(jobsList.length / 2))}</div>
      </div>
    </div>
  );
};

JobsList.propTypes = {
  jobs: PropTypes.arrayOf(PropTypes.object),
  textStrings: PropTypes.arrayOf(PropTypes.object).isRequired,
};

JobsList.defaultProps = {
  jobs: [],
};

export default JobsList;



// WEBPACK FOOTER //
// ./app/components/company/jobs-list.jsx